import React from 'react';
import ModalWrapper, {withOnClose} from "./ModalWrapper";
import Translator from "../../requests/apa/Translator";
import Asset from "../../requests/apa/Asset";
import {HIDE_MODAL} from "../../actions/modal";
import store from "../../store";
import Utils from "../../utils/Utils";
import DeviceStorage from "../DeviceStorage/DeviceStorage";
import './styles/AAFModalHBOPlaybackError.scss';

export const AAFModalHBOPlaybackErrorComponent = (props) => {

  const {errorCode, groupId} = props;

  const assetDefault = Asset.get(`PlayerVod_Falla_Icono`, 'PlayerVod_Falla_Icono');
  const titleDefault = Translator.get(`PlayerVod_Falla_TextoTitulo`, `PlayerVod_Falla_TextoTitulo`);
  const descriptionDefault = Translator.get(`PlayerVod_Falla_TextoDescripcion`, `PlayerVod_Falla_TextoDescripcion`);
  const primaryButtonTextDefault = Translator.get(`PlayerVod_Falla_TextoBotonPrimario`, 'PlayerVod_Falla_TextoBotonPrimario');
  const secondaryButtonTextDefault = Translator.get(`PlayerVod_Falla_TextoBotonSecundario`, 'PlayerVod_Falla_TextoBotonSecundario');

  const asset = Asset.get(`PlayerVod_Falla_Icono_${errorCode}`, assetDefault);
  const title = Translator.get(`PlayerVod_Falla_TextoTitulo_${errorCode}`, titleDefault);
  const description = Translator.get(`PlayerVod_Falla_TextoDescripcion_${errorCode}`, descriptionDefault);
  const primaryButtonText = Translator.get(`PlayerVod_Falla_TextoBotonPrimario_${errorCode}`, primaryButtonTextDefault);
  const secondaryButtonText = Translator.get(`PlayerVod_Falla_TextoBotonSecundario_${errorCode}`, secondaryButtonTextDefault);

  const player_vod_falla_redirect = Utils.getApaMetadataKey('player_vod_falla_redirect', {'default': '/node/homeuser'})
  const region = DeviceStorage.getItem('region');
  const redirect = player_vod_falla_redirect[region] || player_vod_falla_redirect['default']

  console.log("llavesss:", {
    title,
    asset,
    description,
  })

  const p = {
    alwaysEnabled: true,
    aafNewStyle: true,
    className: 'aaf-modal',
    showLogo: false,
    asset,
  };

  const handleRedirect = () => {
    props.history.push(redirect);
    store.dispatch({type: HIDE_MODAL});
  }

  return (
    <ModalWrapper {...p}>
      <div className='AAFModalHBOPlaybackError'>
        <h1>{title}</h1>
        <div className='AAFModalHBOPlaybackError__Description'>
          <p>
            {description}
          </p>
        </div>
        <div className='AAFModalHBOPlaybackError__ButtonContainer'>
          <a href="#" className='focusable' onClick={() => {
            if (groupId) {
              props.history.push(`/vcard/${groupId}`);
              store.dispatch({type: HIDE_MODAL});
              return;
            }
            handleRedirect();
          }}>
            <div>{primaryButtonText}</div>
          </a>
          <a href="#" className='focusable' onClick={handleRedirect}>
            <div className='secondary'>{secondaryButtonText}</div>
          </a>
        </div>
      </div>
    </ModalWrapper>
  );
}

export const AAFModalHBOPlaybackError = withOnClose(AAFModalHBOPlaybackErrorComponent);




// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalHBOPlaybackError.jsx